// src/components/shared/Header.jsx
import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";

const Header = ({ isOwner, bookData, customStyling, navigate }) => {
  const [isSquare, setIsSquare] = useState(true);

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setIsSquare(naturalWidth === naturalHeight);
  };

  const logoHeight = bookData?.headerSettings?.logoHeight ?? 40;
  const isSmall = typeof window !== "undefined" && window.innerWidth < 768;

  return (
    <div className="flex items-center gap-2">
      {/* Back Button for Owner */}
      {isOwner && (
        <button
          onClick={() => navigate("/dashboard")}
          className="p-0 hover:bg-gray-100 rounded-lg transition-colors"
          title="Return to Dashboard"
        >
          <ArrowLeft className="h-5 w-5 text-gray-600" />
        </button>
      )}

      {/* Logo */}
      {bookData?.logoUrl && (
        <div className="flex-shrink-0">
          <img
            src={bookData.logoUrl}
            alt={`${bookData.title || bookData.botName} logo`}
            style={{
              height: `${logoHeight}px`,
              filter: `invert(${bookData?.styling?.logoInvert || 0}%)`,
              maxWidth: isSmall ? "300px" : "100%",
              width: "auto",
            }}
            className="w-auto object-contain rounded-lg"
            onLoad={handleImageLoad}
          />
        </div>
      )}

      {/* Title and Description */}
      {(isSquare || !bookData?.logoUrl) && (
        <div className="min-w-0">
          <h1
            className="text-2xl font-bold text-gray-900 truncate"
            style={{ color: customStyling?.primaryColor }}
          >
            { bookData?.botName || bookData?.title || "Untitled Book" }
          </h1>

          {bookData?.description && (
            <p className="text-gray-600 mt-1 text-sm line-clamp-2">
              {bookData?.description}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
